import script from "./ArticleDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ArticleDetailView.vue?vue&type=style&index=0&id=47d13d99&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d13d99"]])

export default __exports__